import { firestore } from "../firebase/firestore"

export const getConfig = (doc_id) => {
    return firestore.collection('config_public').doc(doc_id).get()
};